'use client';

import { usePathname } from 'next/navigation';

export default function AuthWrapper({ children }) {
  const pathname = usePathname();

  // Since we're using cookie-based auth with middleware handling all protection,
  // we don't need to check auth state here. Middleware handles everything.
  // We could add a loading state here if needed, but it's not necessary
  // as the middleware is very fast.

  // Render children - middleware handles the actual protection
  return children;
}
